class XXLSection extends HTMLElement {
  connectedCallback() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mediaQuery.matches) return;

    const target = this.querySelector('.xxl-section__left-wrapper');
    if (!target) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
          } else {
            this.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    this.observer.observe(target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('xxl-section', XXLSection);
